// frontend/src/site/renderer/SiteRendererPure.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useSite } from '../SiteContext';
import {
  searchProperties,
  buildMicrositeAlgoliaParamsFromSearch,
} from '@/services/searchClient';

import { TemplateCorretorLovableOrchestrator } from '../templates/TemplateCorretorLovable/orchestrator';

export default function SiteRendererPure({ model, handle }) {
  const {
    loading,
    isReady,
    perfilSite,
    theme,
    estrutura,
    conteudo,
    ownerWhatsUrl,
  } = useSite();

  const { search } = useLocation();

  const [properties, setProperties] = useState([]);
  const [loadingProps, setLoadingProps] = useState(true);

  const micrositeParams = useMemo(() => {
    return buildMicrositeAlgoliaParamsFromSearch(search);
  }, [search]);

  /* ===========================================
     Buscar imóveis do microsite via Algolia
  =========================================== */
  useEffect(() => {
    let alive = true;

    async function loadProperties() {
      if (!handle) return;

      try {
        setLoadingProps(true);

        const res = await searchProperties({
          handle,
          queryText: micrositeParams.queryText || '',
          page: 0,
          hitsPerPage: 12,
          params: {
            ...(micrositeParams.params || {}),
          },
        });

        if (!alive) return;

        setProperties(res?.items || []);
      } catch (err) {
        console.warn('Erro ao buscar imóveis:', err?.message || err);
        if (!alive) return;
        setProperties([]);
      } finally {
        alive && setLoadingProps(false);
      }
    }

    loadProperties();

    return () => {
      alive = false;
    };
  }, [handle, micrositeParams]);

  /* ===========================================
     Loading geral do site
  =========================================== */
  if (loading || !isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-muted-foreground">Carregando site…</div>
      </div>
    );
  }

  if (!perfilSite) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-muted-foreground">Site não encontrado</div>
      </div>
    );
  }

  /* ===========================================
     Contexto que vai para o Orquestrador
  =========================================== */
  const ctx = {
    theme,
    estrutura,
    conteudo,
    perfilSite,
    ownerWhatsUrl,
    properties,
    handle,
  };

  /* ===========================================
     Render por modelo
  =========================================== */
  if (model === 'TemplateCorretorLovable') {
    return TemplateCorretorLovableOrchestrator.render({
      ctx,
      slug: handle,
    });
  }

  return null;
}
